import { useI18n } from 'vue-i18n';
import * as yup from 'yup';

export default () => {
  const { t } = useI18n();
  const schema = yup.object().shape({
    reason: yup.string().required(t('errorMessages.required')),
    startDateTime: yup.date().required(t('errorMessages.required')),
    endDateTime: yup
      .date()
      .required()
      .when('startDateTime', (startDateTime, schema) => {
        return schema.test({
          message: t('errorMessages.calendar.endDateBeforeStartDate'),
          // @ts-expect-error FIXME: Parameter 'endDateTime' implicitly has an 'any' type.
          test: (endDateTime) => endDateTime > startDateTime,
        });
      }),
  });

  return {
    schema,
  };
};
